

































































import { Component, Vue } from 'vue-property-decorator';
import LogoUnion from '@/components/merchant/LogoUnion.vue';
import merchantApi from '@/api/merchant';
import { ServerResponse } from '@/interface/common';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'Validate',
  components: {
    LogoUnion
  },
  filters: {
    // eslint-disable-next-line
    showPrice(item: any) {
      if (item.saleType === 'SELL') {
        return `${ item.sellPrice }/元`;
      } else {
        return `${ item.dailyRental }/天起`;
      }
    }
  }
})

export default class Validate extends Vue {
  invitationCode = '';
  productList = [];
  showRegisterBox = false;

  created() {
    document.title = '俏租机';
    this.getActiveProduct();
    this.invitationCode = getUrlParam('invitationCode');
  }

  // 获取商品数据
  getActiveProduct() {
    this.$http({
      url: `${ merchantApi.getActiveProduct.url }/1374610765763448832`,
      method: merchantApi.getActiveProduct.method
    }).then((res: ServerResponse) => {
      const data = res.data || {};

      this.productList = data.items ? data.items : [];
    });
  }

  // 去商品详情
  goToProductDetail(productId: string) {
    const scheme = encodeURIComponent(`alipays://platformapi/startapp?appId=2021001155694219&page=pagesA/product/productdetail?id=${ productId }&scene=${ this.invitationCode }`);

    window.location.href = `https://ds.alipay.com/?scheme=${ scheme }`;
  }

  // 展示注册弹窗
  goToRegister() {
    this.showRegisterBox = true;
  }
}
